import { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Select,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Layout,
  Typography,
  Spin,
  Checkbox,
  TreeSelect,
  notification,
} from 'antd';
import { useParams } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import useHandbook from '@hooks/useHandbook';
import dayjs from 'dayjs';
import TreeSelectHandbook from '@modules/TreeSelect/TreeSelectHandook';
import DateMask from '@modules/Edo/DateMask';
import CustomLoader from '@components/UI/CustomLoader/CustomLoader';
import { getDocData } from '@modules/Agreement/getDocData';
import api from '@modules/Quotation/services';
import SubjectCard from '../MainContract/MainContractObject/ObjectCardDynamic/SubjectCard';
import useAuth from '@hooks/useAuth';
import './index.scss';
import axios from 'axios';
import GenApplicationRequest from './GenApplicationRequest';

const { Content } = Layout;
const { Title } = Typography;

interface Props {
  title: string;
}
type Action = {
  type: 'settings' | 'getDictis' | 'getSQLDictis' | 'loadingSettings';
  payload?: any;
};

interface State {
  doc_row: any;
  doc_additional: any;
  data_docrow: any;
  data_addatr: any;
  isLoading: boolean;
  contractID: string | null;
  contract: string | null;
  formular: any;
  dictisList: any;
  sqlDictisList: any;
  servreq: any;
}

const initialState: State = {
  doc_row: null,
  doc_additional: null,
  data_docrow: null,
  data_addatr: null,
  isLoading: false,
  contractID: null,
  contract: null,
  formular: null,
  dictisList: null,
  servreq: null,
  sqlDictisList: {
    valN3: null,
    valN22: null,
    valN30: null,
  },
};

const reducer = (draft = initialState, action: Action) => {
  switch (action.type) {
    case 'settings': {
      draft.doc_row = action.payload.doc_row;
      draft.doc_additional = action.payload.doc_additional;
      draft.data_docrow = action.payload.data_docrow;
      draft.data_addatr = action.payload.data_addatr;
      draft.contractID = action.payload.contract_id;
      draft.contract = action.payload.contract;
      draft.formular = action.payload.formular;
      draft.servreq = action.payload.servreq;
      break;
    }
    case 'loadingSettings': {
      draft.isLoading = action.payload;
      break;
    }
    case 'getDictis': {
      draft.dictisList = action.payload;
      break;
    }
    case 'getSQLDictis': {
      draft.sqlDictisList = action.payload;
      break;
    }
    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
};
const { Option } = Select;
function GenApplication({ title = 'Mycent.kz' }: Props) {
  const [state, dispatch] = useImmerReducer(reducer, initialState);
  const {
    doc_row,
    doc_additional,
    isLoading,
    contractID,
    contract,
    dictisList,
    sqlDictisList,
    servreq,
  } = state;
  const [formularForm] = Form.useForm();
  const [tabularForm] = Form.useForm();
  const [attributeForm] = Form.useForm();
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const { handbookList, isLoadingHandbookList } = useHandbook('cDocClass');
  const { id } = useParams();
  const [docData, setDocData] = useState<any>(null); // <-- Add state for Docs.docs[0] with correct typing
  const auth = useAuth();
  const [rowId, setRowId] = useState<any>(null);

  const transformToTreeData = (nodes) => {
    if (!nodes || !Array.isArray(nodes)) return [];
    return nodes.map((node) => ({
      title: node.full_name,
      value: node.foreign_id,
      children: transformToTreeData(node.children),
    }));
  };

  const setFormFields = (
    form: any,
    fields: any[],
    data: any,
    type: 'tabular' | 'attribute'
  ) => {
    const formValues = {};
    if (!fields || !data) {
      return;
    }

    if (type === 'tabular' && data) {
      fields.forEach((field) => {
        const valueKey = `${field.rowcolumn.toUpperCase()}_VALUE`;
        const rawValue = data[valueKey];

        if (rawValue !== undefined && rawValue !== null) {
          switch (field.code) {
            case 'DATE':
              const date = dayjs(rawValue, 'DD.MM.YYYY');
              formValues[field.rowcolumn] = date.isValid() ? date : undefined;
              break;
            case 'DICTI':
            case 'DICTI_SQL':
            case 'DICTI_SQL_NAME':
              formValues[field.rowcolumn] =
                data[field.rowcolumn.toUpperCase()] !== 0
                  ? Number(data[field.rowcolumn.toUpperCase()])
                  : undefined;
              break;
            case 'CHECKBOX':
              formValues[field.rowcolumn] = rawValue === '1';
              break;
            case 'SUBJECT':
              formValues[field.rowcolumn] =
                data[field.rowcolumn?.toUpperCase()] !== 0
                  ? Number(data[field.rowcolumn?.toUpperCase()])
                  : undefined;
              break;
            default:
              formValues[field.rowcolumn] =
                rawValue !== 0 ? rawValue : undefined;
              break;
          }
        } else {
          formValues[field.rowcolumn] = undefined;
        }
      });
      form.setFieldsValue({ ...formValues, isn: data.ISN });
    } else if (type === 'attribute' && data) {
      fields.forEach((field, index) => {
        const rawValue = data[index]?.value;
        if (rawValue !== undefined && rawValue !== null) {
          switch (field.code) {
            case 'DATE':
              const date = dayjs(rawValue, 'DD.MM.YYYY');
              formValues[field.attrisn] = date.isValid() ? date : undefined;
              break;
            case 'DICTI':
            case 'DICTI_SQL':
            case 'DICTI_SQL_NAME':
              formValues[field.attrisn] =
                data[index]?.valn != 0 ? Number(data[index]?.valn) : undefined;
              break;
            case 'CHECKBOX':
              formValues[field.attrisn] = rawValue === '1';
              break;
            default:
              formValues[field.attrisn] = rawValue != 0 ? rawValue : undefined;
              break;
          }
        } else {
          formValues[field.attrisn] = undefined;
        }
      });
      form.setFieldsValue(formValues);
    }
  };

  const fetchData = async (id) => {
    try {
      dispatch({ type: 'loadingSettings', payload: true });
      const values = await getDocData(id);

      dispatch({
        type: 'settings',
        payload: {
          doc_row: values.DocSpecs.docrow,
          doc_additional: values.DocSpecs.addattr,
          data_docrow: values.DocRow[0],
          data_addatr: values.AddAttr.addatr,
          contract_id: values.Docs.docs[0].refdocisn,
          contract: values.Docs.docs[0].refdocisn_name,
          formular: values.Docs.docs[0],
          servreq: values.Docs.servreq,
        },
      });
      if (values.DocRow[0]) {
        setRowId(values.DocRow[0].ISN);
      }

      setDocData(values.Docs.docs[0]);

      formularForm.setFieldsValue({
        document_id: values.Docs.docs[0].id,
        class_id: 7646,
        status_id: Number(values.Docs.docs[0].statusisn),
        employee: values.Docs.docs[0].emplisn_name,
        subject: values.Docs.docs[0].subjisn,
        subject_fullname: values.Docs.docs[0].subjisn_name,
        pDatebeg: dayjs(values.Docs.docs[0].datebeg, 'DD.MM.YYYY').isValid()
          ? dayjs(values.Docs.docs[0].datebeg, 'DD.MM.YYYY')
          : null,
        pDateend: dayjs(values.Docs.docs[0].dateend, 'DD.MM.YYYY').isValid()
          ? dayjs(values.Docs.docs[0].dateend, 'DD.MM.YYYY')
          : null,
      });
      setFormFields(
        tabularForm,
        values.DocSpecs.docrow,
        values.DocRow[0],
        'tabular'
      );
      setFormFields(
        attributeForm,
        values.DocSpecs.addattr,
        values.AddAttr.addatr,
        'attribute'
      );

      getDictis([
        ...values.DocSpecs.docrow.filter((item) => item.code === 'DICTI'),
        ...values.DocSpecs.addattr.filter((item) => item.code === 'DICTI'),
      ]);

      const sqlFields = values.DocSpecs.docrow.filter(
        (item) => item.code === 'DICTI_SQL'
      );
      const sqlPromises = sqlFields.map(async (item) => {
        const val = await getSQLDictis(item.rowcolumn);
        return { [item.rowcolumn]: val };
      });

      const resolvedSqlArray = await Promise.all(sqlPromises);
      const newSqlValues = Object.assign({}, ...resolvedSqlArray);

      dispatch({
        type: 'getSQLDictis',
        payload: { ...initialState.sqlDictisList, ...newSqlValues },
      });
    } catch (error) {
      let message;

      if (axios.isAxiosError(error) && error.response) {
        message = error.response.data.message;
      } else {
        message = String(error);
      }

      notification.info({
        message: 'Ошибка',
        description: message,
      });
    } finally {
      dispatch({ type: 'loadingSettings', payload: false });
    }
  };
  const getSQLDictis = async (field) => {
    if (tabularForm.getFieldsValue().isn) {
      const { data } = await api.auto.getSQLDictiByIsn({
        pRowISN: tabularForm.getFieldsValue().isn,
        pColumn: field,
      });
      return data.data;
    } else {
      return [];
    }
  };
  const getDictis = async (form_data) => {
    const dictisPromises = form_data.map(async (item) => {
      try {
        const { data } = await api.auto.getDictiByIsn({
          isn: item.dictiisn ? item.dictiisn : item.attrisn,
        });
        const key = item.rowcolumn || item.attrisn;
        return { [key]: data.data.children };
      } catch (error) {
        console.warn(
          `Ошибка при получении справочника для item ${
            item.dictiisn || item.attrisn
          }:`,
          error
        );
        return null; // или можно вернуть { [key]: [] } если нужен пустой список
      }
    });
    const dictisArray = await Promise.all(dictisPromises);
    const validDictis = dictisArray.filter(Boolean);
    const dictis = Object.assign({}, ...validDictis);

    dispatch({ type: 'getDictis', payload: dictis });
  };
  function toLowerCaseKeys(obj: Record<string, any>) {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key.toLowerCase()] = obj[key];
      return acc;
    }, {} as Record<string, any>);
  }
  // elem.column_name, data.data[0].ISN, 'SUBJECT'
  const onChangeSubject = (column, value, type) => {
    handleSaveTabular(value, column);
  };
  const handleSaveTabular = async (e, field) => {
    const { data } = await api.quotation.createGenApplication({
      pDatebeg: dayjs(formularForm.getFieldsValue().pDatebeg).format(
        'DD.MM.YYYY'
      ),
      pDateend: dayjs(formularForm.getFieldsValue().pDateend).format(
        'DD.MM.YYYY'
      ),
      pUserISN: auth.user.data.user_info.foreign_id,
      pSubjISN: Number(formularForm.getFieldsValue().subject),
      pParam: toLowerCaseKeys({
        ...tabularForm.getFieldsValue(),
        isn: tabularForm.getFieldValue('isn')
          ? tabularForm.getFieldValue('isn')
          : rowId,
        vald25: tabularForm.getFieldValue('valD25') ? dayjs(tabularForm.getFieldValue('valD25')).format('DD.MM.YYYY') : null,
        docisn: docData.isn,
      }),
      pStatusISN: formularForm.getFieldsValue().status_id,
      pDocISN: id,
    });
    if (data.data[7].value && data.data[7].value[0].ISN) {
      setRowId(data.data[7].value[0].ISN);

      tabularForm.setFieldValue('isn', data.data[7].value[0].ISN);
    } else if (data.data[7].value[0]['ERROR']) {
      notification.info({
        message: 'Ошибка',
        description: data.data[7].value[0]['ERROR'],
      });
      formularForm.setFieldValue('status_id', 2516);
    }
  };
  const handleSaveAttribute = async (e, field) => {
    api.saveQuotation.attributeSave({
      agr_attributes: [
        {
          attr_isn: Number(field.attrisn),
          class_isn: 220568,
          val_n: e,
          obj_isn: id, //isn document
          user_isn: auth.user.data.user_info.foreign_id,
        },
      ],
    });
  };

  const handleDropdownVisibleChange = async (open, field) => {
    if (open) {
      const data = await getSQLDictis(field.rowcolumn);
      dispatch({
        type: 'getSQLDictis',
        payload: { ...sqlDictisList, [field.rowcolumn]: data },
      });
    }
  };
  const handleSave = async () => {
    try {
      console.log(attributeForm.getFieldsValue());
      if(!attributeForm.getFieldsValue()[860231]){
        notification.error({
          message: 'Ошибка',
          description: 'Выберите тип продаж',
        });
        return;
      }
      setIsLoadingSave(true);
      formularForm.setFieldValue('status_id', 2522);
      await handleSaveTabular(null, null);
      notification.success({
        message: 'Данные успешно сохранены!',
      });
      setIsLoadingSave(false);
    } catch (error) {
      notification.error({
        message: 'При сохранении произошла ошибка!',
      });
    }
  };
  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    /*
      Просмотр документа
      Получаем данные документа и настройки домукента
    */
    if (id) {
      fetchData(id);
    }
  }, [id]);

  if (isLoadingHandbookList) {
    return <CustomLoader />;
  } else {
    if (!isLoading) {
      DateMask();
    }
  }
  console.log(servreq);

  return (
    <>
      <Form.Provider>
        <CustomLoader spinning={isLoading}>
          <Content
            data-testid="edo-content"
            className="gen-application-content"
          >
            <Card>
              <Title
                data-testid="edo-title"
                level={5}
                type="secondary"
                className="mb-5"
              >
                Ген.заявка
              </Title>
              <Form
                layout="vertical"
                name="documentForm"
                form={formularForm}
                // onFinish={handleDocumentCreate}
              >
                <Row gutter={24} align="bottom">
                  <Col span={8} xs={24} xl={8}>
                    <Form.Item
                      label="Тип документа"
                      rules={[
                        {
                          required: true,
                          message: 'Обязательное поле',
                        },
                      ]}
                      name="class_id"
                    >
                      <TreeSelectHandbook
                        // value={7646}
                        handbookList={handbookList}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} xs={24} xl={8}>
                    <Form.Item label="ID документа" name="id" hidden>
                      <Input disabled />
                    </Form.Item>
                    <Form.Item name="subject" hidden>
                      <Input disabled />
                    </Form.Item>
                    <Form.Item name="pDatebeg" hidden noStyle>
                      <DatePicker
                        className="dateMask"
                        style={{ width: '100%' }}
                        format={'DD.MM.YYYY'}
                        disabled
                      />
                    </Form.Item>
                    <Form.Item name="pDateend" hidden noStyle>
                      <DatePicker
                        className="dateMask"
                        style={{ width: '100%' }}
                        format={'DD.MM.YYYY'}
                        disabled
                      />
                    </Form.Item>
                    <Form.Item label="Номер документа №" name="document_id">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col span={8} xs={24} xl={8}>
                    <Form.Item label="Статус" name="status_id">
                      <Select
                        onChange={(e) => {
                          handleSaveTabular(e, { status_id: e });
                        }}
                      >
                        <Option value={2515} key="2515">
                          Aннулирован
                        </Option>
                        <Option value={2516} key="2516">
                          В работе
                        </Option>
                        <Option value={2522} key="2522">
                          На подписи
                        </Option>
                        <Option value={2518} key="2518">
                          Подписан
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8} xs={24} xl={8}>
                    <Form.Item label="Куратор" name="employee">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col span={8} xs={24} xl={8}>
                    <Form.Item label="Контрагент" name="subject_fullname">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col span={8} xs={24} xl={8}>
                    <Form.Item
                      label="Дата регистрации"
                      name="date_reg"
                      initialValue={dayjs()}
                      required
                    >
                      <DatePicker
                        className="dateMask"
                        style={{ width: '100%' }}
                        format={'DD.MM.YYYY'}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
            <Card style={{ marginTop: '30px' }}>
              <Title
                data-testid="edo-title"
                level={5}
                type="secondary"
                className="mb-5"
              >
                Табличная часть
              </Title>
              <Spin spinning={isLoading}>
                <Form layout="vertical" form={tabularForm}>
                  <Form.Item name="isn" hidden noStyle>
                    <Input />
                  </Form.Item>
                  <Row gutter={24} align="bottom">
                    {doc_row?.map((field, index) => {
                      switch (field.code) {
                        case 'NUMBER':
                        case 'FLOAT':
                        case 'TEXT':
                        case 'DOCS':
                        case 'INTEGER': {
                          return (
                            <Col span={8} xs={24} xl={8} key={field.rowcolumn}>
                              <Form.Item
                                label={field.fieldname}
                                name={field.rowcolumn}
                              >
                                <Input
                                  onChange={(e) => {
                                    handleSaveTabular(e, field);
                                  }}
                                  disabled={
                                    docData
                                      ? Number(docData.statusisn) !== 2516
                                      : true
                                  }
                                  placeholder={field.fieldname}
                                />
                              </Form.Item>
                            </Col>
                          );
                        }
                        case 'DICTI_SQL':
                          return (
                            <Col span={8} xs={24} xl={8} key={field.rowcolumn}>
                              <Form.Item
                                label={field.fieldname}
                                name={field.rowcolumn}
                              >
                                <Select
                                  onDropdownVisibleChange={(open) =>
                                    handleDropdownVisibleChange(open, field)
                                  }
                                  disabled={
                                    docData
                                      ? Number(docData.statusisn) !== 2516
                                      : true
                                  }
                                  onSelect={(e) => {
                                    handleSaveTabular(e, field);
                                  }}
                                  placeholder={field.fieldname}
                                  options={
                                    sqlDictisList &&
                                    sqlDictisList[field.rowcolumn]?.map((d) => {
                                      return {
                                        label: d.FULLNAME,
                                        value: d.ISN,
                                      };
                                    })
                                  }
                                />
                              </Form.Item>
                            </Col>
                          );
                        case 'DICTI': {
                          if (field.rowcolumn === 'valN1') {
                            return (
                              <Col
                                span={8}
                                xs={24}
                                xl={8}
                                key={field.rowcolumn}
                              >
                                <Form.Item
                                  label={field.fieldname}
                                  name={field.rowcolumn}
                                >
                                  <TreeSelect
                                    onSelect={(e) => {
                                      handleSaveTabular(e, field);
                                    }}
                                    showSearch
                                    style={{ width: '100%' }}
                                    dropdownStyle={{
                                      maxHeight: 400,
                                      overflow: 'auto',
                                    }}
                                    placeholder={field.fieldname}
                                    allowClear
                                    treeData={transformToTreeData(
                                      dictisList && dictisList[field.rowcolumn]
                                    )}
                                    treeNodeFilterProp="title"
                                    disabled={
                                      docData
                                        ? Number(docData.statusisn) !== 2516
                                        : true
                                    }
                                  />
                                </Form.Item>
                              </Col>
                            );
                          } else {
                            return (
                              <Col
                                span={8}
                                xs={24}
                                xl={8}
                                key={field.rowcolumn}
                              >
                                <Form.Item
                                  label={field.fieldname}
                                  name={field.rowcolumn}
                                >
                                  <Select
                                    disabled={
                                      docData
                                        ? Number(docData.statusisn) !== 2516
                                        : true
                                    }
                                    onSelect={(e) => {
                                      handleSaveTabular(e, field);
                                    }}
                                    placeholder={field.fieldname}
                                    options={
                                      dictisList &&
                                      dictisList[field.rowcolumn]?.map((d) => {
                                        return {
                                          label: d.full_name,
                                          value: d.foreign_id,
                                        };
                                      })
                                    }
                                  />
                                </Form.Item>
                              </Col>
                            );
                          }
                        }
                        case 'CHECKBOX': {
                          return (
                            <Col span={8} xs={24} xl={8} key={field.rowcolumn}>
                              <Form.Item
                                name={field.rowcolumn}
                                valuePropName="checked"
                              >
                                <Checkbox
                                  onChange={(e) => {
                                    handleSaveTabular(
                                      e.target.checked ? '1' : '0',
                                      field
                                    );
                                  }}
                                  disabled={
                                    docData
                                      ? Number(docData.statusisn) !== 2516
                                      : true
                                  }
                                >
                                  {field.fieldname}
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          );
                        }
                        case 'SUBJECT': {
                          return (
                            <SubjectCard
                              disabled={
                                docData
                                  ? Number(docData.statusisn) !== 2516
                                  : true
                              }
                              onChange={onChangeSubject}
                              className="gen-application-subject-card"
                              // col={8}
                              xs={24}
                              lg={8}
                              key={`fullname-${field.rowcolumn}`}
                              elem={{
                                column_name: field.rowcolumn,
                                full_name: `fullname-${field.rowcolum}`,
                                label: field.fieldname,
                              }}
                              mainForm={tabularForm}
                            />
                          );
                        }
                        case 'DATE': {
                          return (
                            <Col span={8} xs={24} xl={8} key={field.rowcolumn}>
                              <Form.Item
                                label={field.fieldname}
                                name={field.rowcolumn}
                              >
                                <DatePicker
                                  onChange={(e) => {
                                    handleSaveTabular(
                                      dayjs(e).format('DD.MM.YYYY'),
                                      field
                                    );
                                  }}
                                  format="DD.MM.YYYY"
                                  disabled={
                                    docData
                                      ? Number(docData.statusisn) !== 2516
                                      : true
                                  }
                                  style={{ width: '100%' }}
                                  placeholder={field.fieldname}
                                />
                              </Form.Item>
                            </Col>
                          );
                        }
                      }
                    })}
                  </Row>
                </Form>
              </Spin>
            </Card>
            <Card style={{ marginTop: '30px' }}>
              <Title
                data-testid="edo-title"
                level={5}
                type="secondary"
                className="mb-5"
              >
                Дополнительные сведения
              </Title>
              <Spin spinning={isLoading}>
                <Form layout="vertical" form={attributeForm}>
                  <Row gutter={24} align="bottom">
                    {doc_additional?.map((field, index) => {
                      switch (field.code) {
                        case 'NUMBER':
                        case 'FLOAT':
                        case 'TEXT':
                        case 'DOCS':
                        case 'INTEGER': {
                          return (
                            <Col span={8} xs={24} xl={8} key={field.rowcolumn}>
                              <Form.Item
                                label={field.fullname}
                                name={field.attrisn}
                              >
                                <Input
                                  onChange={(e) => {
                                    handleSaveAttribute(e.target.value, field);
                                  }}
                                  disabled={
                                    docData
                                      ? Number(docData.statusisn) !== 2516
                                      : true
                                  }
                                  placeholder={field.fullname}
                                />
                              </Form.Item>
                            </Col>
                          );
                        }
                        case 'DICTI':
                        case 'DICTI_SQL':
                        case 'DICTI_SQL_NAME': {
                          return (
                            <Col span={8} xs={24} xl={8} key={field.rowcolumn}>
                              <Form.Item
                                label={field.fullname}
                                name={field.attrisn}
                                required={field.attrisn === '860231'}
                              >
                                <Select
                                  onSelect={(e) => {
                                    handleSaveAttribute(e, field);
                                  }}
                                  disabled={
                                    docData
                                      ? Number(docData.statusisn) !== 2516
                                      : true
                                  }
                                  placeholder={field.fullname}
                                  options={
                                    dictisList &&
                                    dictisList[field.attrisn]?.map((d) => {
                                      return {
                                        label: d.full_name,
                                        value: d.foreign_id,
                                      };
                                    })
                                  }
                                />
                              </Form.Item>
                            </Col>
                          );
                        }
                        case 'CHECKBOX': {
                          return (
                            <Col span={8} xs={24} xl={8} key={field.rowcolumn}>
                              <Form.Item
                                name={field.attrisn}
                                valuePropName="checked"
                              >
                                <Checkbox
                                  onChange={(e) => {
                                    handleSaveAttribute(
                                      e.target.checked ? '1' : '0',
                                      field
                                    );
                                  }}
                                  disabled={
                                    docData
                                      ? Number(docData.statusisn) !== 2516
                                      : true
                                  }
                                >
                                  {field.fullname}
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          );
                        }
                        case 'DATE': {
                          return (
                            <Col span={8} xs={24} xl={8} key={field.attrisn}>
                              <Form.Item
                                label={field.fullname}
                                name={field.attrisn}
                              >
                                <DatePicker
                                  onChange={(e) => {
                                    handleSaveAttribute(e, field);
                                  }}
                                  format="DD.MM.YYYY"
                                  disabled={
                                    docData
                                      ? Number(docData.statusisn) !== 2516
                                      : true
                                  }
                                  style={{ width: '100%' }}
                                  placeholder={field.fullname}
                                />
                              </Form.Item>
                            </Col>
                          );
                        }
                      }
                      return (
                        <Col span={8} xs={24} xl={8}>
                          <Form.Item label={field.fullname}>
                            <Input
                              onChange={(e) => {
                                handleSaveAttribute(e, field);
                              }}
                              placeholder={field.fullname}
                              disabled={
                                docData
                                  ? Number(docData.statusisn) !== 2516
                                  : true
                              }
                            />
                          </Form.Item>
                        </Col>
                      );
                    })}
                  </Row>
                </Form>
              </Spin>
            </Card>
            <GenApplicationRequest
              userForeignId={auth?.user?.data?.user_info?.foreign_id}
              agrIsn={docData?.isn}
              quotationData={docData}
              productIsn={docData?.productisn}
              servreq={servreq}
            />
            <Button
              type="primary"
              className="mt-3"
              size="large"
              onClick={handleSave}
              style={{ minWidth: ' 200px' }}
              disabled={docData ? Number(docData.statusisn) !== 2516 : true}
            >
              Сохранить
            </Button>
            {contractID && (
              <a href={`/genContract/${contractID}?showSide=false`}>
                <Button type="primary" className="mt-3">
                  Перейти в ген. договор: {contract}
                </Button>
              </a>
            )}
          </Content>
        </CustomLoader>
      </Form.Provider>
    </>
  );
}

export default GenApplication;
